const getLocationOrigin = () => {
    //return window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '')
    return 'https://news.chengyu168.top'
  }
  const url='https://news.chengyu168.top'
  const urlImg='https://news.chengyu168.top'
  const companyName = '诚鱼文化'
  const version = 'V1.0.0'
  const baiduKey = '百度key'
  const cacheFix='mtx_'
  
  export default {
    url,
    version,
    companyName,
    getLocationOrigin,
    baiduKey,
    cacheFix
  }
  